export const FORUM_GROUPS_RESET_STATE = 'FORUM_GROUPS_RESET_STATE';
export const FORUM_GROUPS_CURRENT_ITEM = 'FORUM_GROUPS_CURRENT_ITEM';

export const FORUM_GROUPS_REQUEST_LOADING = 'FORUM_GROUPS_REQUEST_LOADING';
export const FORUM_GROUPS_REQUEST_SUCCESS = 'FORUM_GROUPS_REQUEST_SUCCESS';
export const FORUM_GROUPS_REQUEST_FAILED = 'FORUM_GROUPS_REQUEST_FAILED';

export const FORUM_GROUPS_CURRENT_ACTION = 'FORUM_GROUPS_CURRENT_ACTION';
export const FORUM_GROUPS_RESET_ACTION = 'FORUM_GROUPS_RESET_ACTION';